// extracted by mini-css-extract-plugin
export default {"button":"MainButton_button__1XVBx"};